import {XHRFetcher} from "../../lib/xhr_fetcher";

export class Prefetcher {

    constructor(basePath, onlineApp) {
        this.basePath = basePath;
        this.onlineApp = onlineApp;
        this.cache = {};
    }

    // Injects the content for the URL into a provided callback
    // The content might come immediately from the cache or be async loaded into the cache and then provided to the callback.
    contentFor(url, fragmentId, callback) {
        if (this.hasContent(url)) {
            callback(this.getContent(url, fragmentId));
        } else {
            this.addUrl(url, (response) => {
                callback(this.getContent(url, fragmentId));
            });
        }
    }

    // Removes url (and any existing content) and adds  url and async loads the content.
    addUrl(url, callback=null){
        this.removeUrl(url);
        // The old Loader sent XHR's default `Accept: */*`, so the server returned the first
        // declared respond_to format (HTML page fragments). Preserve that here rather than
        // XHRFetcher's text/javascript default, which would flip format negotiation.
        // On failure the old Loader invoked the callback with null and cached null — preserved.
        const handle = (response) => {
            this.addContent(url, response);
            if (callback) { callback(response) };
        };
        new XHRFetcher(url, { headers: { Accept: '*/*' } }).fetch()
            .then(handle)
            .catch(() => handle(null));
    }

    removeUrl(url) {
        delete this.cache[url];
    }

    hasUrl(url) {
        return this.cache.hasOwnProperty(url);
    }

    addContent(url, content) {
        this.cache[url] = content;
    }

    removeContent(url) {
        if (this.hasContent(url)) {
            this.cache[url] = null;
        };
    }

    getContent(url, fragmentId) {
        let content = this.cache[url];
        if (fragmentId && content && content.includes(fragmentId)){
            let tempEl = document.createElement('div');
            tempEl.innerHTML = content;
            let fragEl = tempEl.querySelector('#'+fragmentId);
            if (fragEl) { content = fragEl.innerHTML };
        }
        return content;
    }

    hasContent(url) {
        if (!this.hasUrl(url)) { return false };
        return this.getContent(url) != null;
    }

}